import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Observable } from 'rxjs';
import { NotificationToastService } from 'app/notification/notification-toast.service';

@Component({
  selector: 'app-manage-customer',
  templateUrl: './manage-customer.component.html',
  styleUrls: ['./manage-customer.component.css'],
  providers:[NotificationToastService, AngularFireDatabase]
})
export class ManageCustomerComponent implements OnInit {
  userData : Observable<any>;
  private userId:string;
  private imageToUpload1 = "assets/images/avatar-4.png";
  from:any;
  user: any;
  constructor(private route: ActivatedRoute, public db:AngularFireDatabase, private nf: NotificationToastService) {
    var data = this.route.snapshot.queryParamMap.get('key');
    this.from = this.route.snapshot.queryParamMap.get('from');
    this.userId = data;
   }

  ngOnInit() {
    if(this.from == "customer")
    {
      this.getUser();
    }
    else
    {
      this.getContacts();
    }
  }
  getUser()
  {
    this.userData = this.db.object("users/"+this.userId);
    this.userData.subscribe(user=>{
      //console.log("userData ",user);
      this.user = user;
    });
  }
  getContacts()
  {
    this.userData = this.db.object("contacts/"+this.userId);
    this.userData.subscribe(user=>{
      //console.log("userData ",user);
      this.user = user;
    });
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/customers/manage-customer/manage-customer.component.ts